import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  key:'customers.customer_modify',
  path: '/customer/customermodify',
  title: 'Customer Detail -  Client ID <<###>> - Billing ID <<##>>',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);